var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { i18n } from '../i18n';
import config from '../config';
/**
 * Global translation function that can be used anywhere in the app
 * @param key - Translation key (can include namespace like 'common:welcome' or just 'welcome')
 * @param options - Translation options (optional)
 * @returns Translated string
 */
export var t = function (key, options) {
    // Check if key contains namespace separator
    if (key.includes(':')) {
        var _a = key.split(':'), namespace = _a[0], translationKey = _a[1];
        return i18n.t(translationKey, __assign({ ns: namespace }, options));
    }
    // Default to common namespace if no namespace specified
    return i18n.t(key, __assign({ ns: config.DEFAULT_NAMESPACE }, options));
};
